import styled, { css, keyframes } from 'styled-components'
import { COLORS } from 'consts/colors'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import { Z_INDEX_FOR_HIDE_REACT_SELECTO_RECTANGLE_DURING_SCROLL } from 'consts/zIndex'
import CrownSvg from 'assets/svgr-icons/Crown.svg'
import { OVERLAY_MAX_WIDTH } from 'consts/sidebar'
import { GRADIENTS, SHADOWS } from 'styles/consts'

const blinkAnimation = keyframes`
  0% {
    background-color: transparent;
    box-shadow: none;
  }
  50% {
    background-color: rgba(65, 54, 193, 0.1);
    box-shadow: 0 0 12px rgba(65, 54, 193, 0.18);
  }
  100% {
    background-color: transparent;
    box-shadow: none;
  }
`

export const Container = styled.div`
  width: ${OVERLAY_MAX_WIDTH}px;
  height: 100%;
  box-sizing: border-box;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  z-index: ${Z_INDEX_FOR_HIDE_REACT_SELECTO_RECTANGLE_DURING_SCROLL};
  background-color: ${COLORS.surface};
  border-radius: 16px;
  box-shadow: ${SHADOWS.panel};

  &[data-flash='1'] {
    animation: ${blinkAnimation} 1s ease-in-out;
  }

  @media only screen and (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    width: 100%;
    height: auto;
    flex: 1;
    min-height: 0;
    border-radius: 0;
    box-shadow: none;
  }
`

export const CrownIcon = styled(CrownSvg)`
  fill: ${COLORS.white};
`

const contentReveal = keyframes`
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

/* Remounts per active tab (keyed) so panel switches fade-slide in. */
export const ContentReveal = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  animation: ${contentReveal} 0.25s ease;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`

export const premiumButtonStyles = css<{
  $isPremium: boolean
}>`
  ${({ $isPremium }) =>
    $isPremium &&
    css`
      background: ${GRADIENTS.premium};

      &:hover {
        background: ${GRADIENTS.premiumHover};
      }
    `}
`
